<template>
  <div v-if="isOpen3DModal">
    <!-- // TODO :- there is an issue regarding to scroll in store page due to modal inside modal -->

    <!-- <DialogModal :show="isOpen3DModal" @close="closeIframeModal" mainClass="modal-margin" -->
    <!-- extraFlex="flex justify-center items-center" headerClass="iframe-modal" extraClass="iframe-modal"> -->
    <!-- <template #header> -->
    <div
      class="close-btn absolute right-2 top-2 sm:block"
      @click="closeIframeModal"
    >
      <button
        class="focus:ring-none flex items-center justify-center rounded-full bg-white p-2.5 text-primary-900 hover:text-primary-900 focus:outline-none"
        type="button"
        tabindex="0"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="2"
          stroke="currentColor"
          aria-hidden="true"
          class="size-6"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>
    <!-- </template> -->
    <!-- <template #content> -->
    <div class="w-full">
      <iframe
        :src="url"
        class="w-full"
        style="height: 650px;"
        title="Stripe"
      />
    </div>
    <!-- </template> -->
  <!-- </DialogModal> -->
  </div>
</template>
<script>
// import DialogModal from "@/Jetstream/DialogModal.vue";
export default {
   
   name: '3DModal',
   components: {
    // DialogModal
   },
   props:{
    url:{
         Type:String,
         required: true,
      },
    isOpen3DModal:{
      Type:Boolean,
      default:false,
    }
   },
   methods: {
    closeIframeModal() {
      this.isOpen3DModal = false
    }
  }
}
</script>
<style scoped>
.close-btn {
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.11));
}
</style>
